import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ActionButtonsSection = ({ status, transactionData }) => {
  const navigate = useNavigate();

  const handleViewTickets = () => {
    navigate('/ticket-verification');
  };

  const handleContactSupport = () => {
    const message = `Hola, necesito ayuda con mi transacción:\n\nReferencia: ${transactionData?.referenceNumber}\nMonto: Bs. ${transactionData?.amount?.toLocaleString()}\nFecha: ${new Date(transactionData.timestamp)?.toLocaleDateString('es-VE')}`;
    const whatsappUrl = `https://wa.me/584121234567?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleDownloadReceipt = () => {
    // Simulate receipt download
    const receiptData = {
      transactionId: transactionData?.transactionId,
      referenceNumber: transactionData?.referenceNumber,
      amount: transactionData?.amount,
      timestamp: transactionData?.timestamp,
      status: status
    };
    
    const dataStr = JSON.stringify(receiptData, null, 2);
    const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
    
    const exportFileDefaultName = `recibo_${transactionData?.referenceNumber}.json`;
    
    const linkElement = document.createElement('a');
    linkElement?.setAttribute('href', dataUri);
    linkElement?.setAttribute('download', exportFileDefaultName);
    linkElement?.click();
  };

  const handleReturnHome = () => {
    navigate('/home-landing');
  };

  const handleRetryPayment = () => {
    navigate('/purchase-flow');
  };

  return (
    <div className="space-y-6">
      {/* Primary Actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {status === 'verified' && (
          <Button
            variant="secondary"
            size="lg"
            onClick={handleViewTickets}
            iconName="Ticket"
            iconPosition="left"
            className="w-full"
          >
            Ver Mis Boletos
          </Button>
        )}

        {(status === 'pending' || status === 'failed') && (
          <Button
            variant="secondary"
            size="lg"
            onClick={handleContactSupport}
            iconName="MessageCircle"
            iconPosition="left"
            className="w-full"
          >
            Contactar Soporte
          </Button>
        )}

        {status === 'failed' && (
          <Button
            variant="outline"
            size="lg"
            onClick={handleRetryPayment}
            iconName="RefreshCw"
            iconPosition="left"
            className="w-full"
          >
            Reintentar Pago
          </Button>
        )}

        <Button
          variant="outline"
          size="lg"
          onClick={handleDownloadReceipt}
          iconName="Download"
          iconPosition="left"
          className="w-full"
        >
          Descargar Recibo
        </Button>
      </div>

      {/* Secondary Actions */}
      <div className="flex flex-col sm:flex-row gap-3 pt-4 border-t border-border">
        <Button
          variant="ghost"
          onClick={handleReturnHome}
          iconName="Home"
          iconPosition="left"
          className="flex-1"
        >
          Volver al Inicio
        </Button>

        <Button
          variant="ghost"
          onClick={() => navigate('/purchase-flow')}
          iconName="Plus"
          iconPosition="left"
          className="flex-1"
        >
          Comprar Más Boletos
        </Button>
      </div>

      {/* Status-specific Information */}
      {status === 'pending' && (
        <div className="bg-warning/10 border border-warning/30 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <Icon name="Info" size={16} className="text-warning mt-0.5" />
            <div>
              <h4 className="font-body font-semibold text-warning mb-2">
                Próximos Pasos
              </h4>
              <ul className="text-sm text-gray-800 space-y-1 font-caption"> {/* Cambiado aquí */}
                <li>• Recibirás una notificación cuando se verifique tu pago</li>
                <li>• Los boletos se asignarán automáticamente tras la verificación</li>
                <li>• Puedes verificar el estado en cualquier momento</li>
                <li>• Si tienes dudas, contacta nuestro soporte</li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {status === 'verified' && (
        <div className="bg-success/10 border border-success/30 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <Icon name="CheckCircle" size={16} className="text-success mt-0.5" />
            <div>
              <h4 className="font-body font-semibold text-success mb-2">
                ¡Felicitaciones!
              </h4>
              <ul className="text-sm text-gray-800 space-y-1 font-caption"> {/* Cambiado aquí */}
                <li>• Tus boletos han sido asignados exitosamente</li>
                <li>• Recibirás notificaciones sobre el sorteo</li>
                <li>• Puedes verificar tus boletos en cualquier momento</li>
                <li>• ¡Buena suerte en el sorteo!</li>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionButtonsSection;